var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusinessHourCopyStack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4 3.33301H18.91C15.97 3.33301 13.64 3.33301 11.8183 3.57967C9.94167 3.83301 8.42333 4.36634 7.22667 5.56801C6.02833 6.76967 5.49667 8.29467 5.245 10.178C5 12.008 5 14.3463 5 17.298V27.028C5 29.5413 6.53333 31.6947 8.71167 32.598C8.6 31.0813 8.6 28.9563 8.6 27.1863V18.8363C8.6 16.7013 8.6 14.8597 8.79667 13.3863C9.00833 11.8063 9.485 10.293 10.7083 9.06467C11.9317 7.83634 13.44 7.35801 15.0133 7.14467C16.48 6.94801 18.3133 6.94801 20.4417 6.94801H25.5583C27.685 6.94801 29.515 6.94801 30.9833 7.14467C30.5435 6.02183 29.7755 5.05757 28.7796 4.37765C27.7836 3.69772 26.6059 3.33368 25.4 3.33301Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 18.9948C11 14.4514 11 12.1798 12.4067 10.7681C13.8117 9.35645 16.0733 9.35645 20.6 9.35645H25.4C29.925 9.35645 32.1883 9.35645 33.595 10.7681C35.0017 12.1798 35 14.4514 35 18.9948V27.0281C35 31.5714 35 33.8431 33.595 35.2548C32.1883 36.6664 29.925 36.6664 25.4 36.6664H20.6C16.075 36.6664 13.8117 36.6664 12.4067 35.2548C11 33.8431 11 31.5714 11 27.0281V18.9948Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessHourCopyStack);
export default __webpack_public_path__ + "static/media/business-hour_copy-stack.e85ec96203f75b2a281b1f49d0caff8e.svg";
export { ForwardRef as ReactComponent };